// extracted by mini-css-extract-plugin
export default {"loginHeader":"LoginPage_loginHeader__VXTSE"};